import { constants } from "redux/constants/redux-constants";

// export const set_selected_location = (payload) => {
//   return { type: constants.LOCATION.SET_SELECTED_LOCATION, payload };
// };
export const set_available_locations = (payload) => {
  return { type: constants.LOCATION.SET_AVAILABLE_LOCATIONS, payload };
};